export default "__VITE_ASSET__Dm6H3PIs__"